module.exports = __webpack_public_path__ + "static/media/MailTrackingIcon.82408be5.png";